/**
 * Normaliza um locale da aplicacao para uma tag BCP 47 valida nas APIs Intl.
 *
 * O locale do Chatwoot e gravado com underscore (`pt_BR`, `zh_CN`), formato que
 * as APIs Intl rejeitam com `RangeError: Invalid language tag`. Todo ponto que
 * entrega um locale dinamico para `Intl.*` ou `toLocale*String` deve passar por
 * aqui.
 *
 * Ordem de resolucao:
 * 1. underscore vira hifen (`pt_BR` vira `pt-BR`);
 * 2. se a tag especifica nao for suportada, cai no idioma base (`pt`);
 * 3. se nem o idioma base for suportado, cai em `en`.
 *
 * @param {string} [locale] locale cru, possivelmente com underscore
 * @returns {string} tag BCP 47 aceita por Intl
 */
export const toIntlLocale = locale => {
  if (!locale || typeof locale !== 'string') return 'en';

  const normalized = locale.replace(/_/g, '-');

  try {
    if (Intl.NumberFormat.supportedLocalesOf([normalized]).length > 0) {
      return normalized;
    }

    const baseLocale = normalized.split('-')[0];
    if (Intl.NumberFormat.supportedLocalesOf([baseLocale]).length > 0) {
      return baseLocale;
    }
  } catch {
    // Tag tao quebrada que nem a canonicalizacao aceita: cai no fallback.
    return 'en';
  }

  return 'en';
};

export default toIntlLocale;
